import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Approved, sendEmailmultiple } from 'src/app/service/modal/approved';
import { ActivatedRoute, Router } from '@angular/router';
import { SubjectService } from 'src/app/service/apiservice/subject.service';
import { Globals } from '../../../globals';
import { ApprovedService } from '../../../service/apiservice/approved.service';
import { FormGroup, Validators, AbstractControl, FormControl, NgForm, FormBuilder } from '@angular/forms';
declare var $;
declare function info_noti(msg: any): any;
@Component({
  selector: 'app-subject-hc',
  templateUrl: './subject-hc.component.html',
  styleUrls: ['./subject-hc.component.css']
})
export class SubjectHcComponent implements OnInit {

  subjectRouteParamId: any;
  subjectGrid: Approved[] = new Array();
  subjectViewData: Approved = new Approved();
  todayDate: any;
  selectedMailList = [];
  showActions: boolean = false;
  approvedAttachmentData: any;
  approvedAttachmentDataShow: any;
  selectedActionList: Approved[] = new Array();
  appvar: Approved;
  approvedObjActionShow = new Approved();
  checkClickCount = 0;
  hoveredIndex;
  @ViewChild('AttachmentCloseForm') attachment_CloseForm: ElementRef;

  //multiple email forward
  emailId;
  sendEmailmultiple = new sendEmailmultiple;

  eyeIconViewData: string = "zmdi-eye-off";
  starIconViewData: string = "zmdi-star-outline";
  constructor(private fb: FormBuilder,private router: Router, private _approvedService: ApprovedService, private route: ActivatedRoute, private _subjectService: SubjectService
    , private chRef: ChangeDetectorRef, private global: Globals) { }

  ngOnInit() {
    localStorage.setItem("Active Route", this.router.url);
    this.global.afterRefreshPageSetToken();
    this.route.params.subscribe(params => this.subjectRouteParamId = params['id']);
    this.GetSubject_Grid();
    this.todayDate = new Date();
    $(".modal-wide").on("show.bs.modal", function () {
      var height = $(window).height() - 80;
      $(this).find(".modal-body").css("max-height", height);
    });
    this.loadSendEmailForm();
  }


  GetSubject_Grid() {
    this._subjectService.GetIndividualSubjectList(this.subjectRouteParamId)
      .subscribe((response) => {


        if ($.fn.dataTable.isDataTable('#subjectDatatable')) {
          $('#subjectDatatable').dataTable().fnClearTable();
          $('#subjectDatatable').dataTable().fnDestroy();
        }

        if ($.fn.dataTable.isDataTable('#subjectDatatable_IsMobile')) {
          $('#subjectDatatable_IsMobile').dataTable().fnClearTable();
          $('#subjectDatatable_IsMobile').dataTable().fnDestroy();
        }
        Object.assign(this.subjectGrid, response);
        this.subjectGrid.forEach((element) => {

          if (element.sub.length == 0) {
            element.subBindGrid = "";
          } else {
            element.sub.forEach((elem) => {
              if (element.subBindGrid == undefined) {
                element.subBindGrid = elem.name
              }
              else {
                element.subBindGrid = element.subBindGrid + ',' + elem.name;
              }
              // element.subBindGrid="";
            })
          }
          if (element.spec.length == 0) {
            element.specBindGrid = "";
          } else {
            element.spec.forEach((elem) => {
              if (element.specBindGrid == undefined) { element.specBindGrid = elem.name }
              else { element.specBindGrid = element.specBindGrid + ',' + elem.name; }
            })
          }
          if (element.remark.length == 0) {
            element.remarkBindGrid = "";
          } else {
            element.remark.forEach((elem) => {
              if (element.remarkBindGrid == undefined) { element.remarkBindGrid = elem.name }
              else { element.remarkBindGrid = element.remarkBindGrid + ',' + elem.name; }
            })
          }
        });
        this.chRef.detectChanges();
        $("#subjectDatatable").DataTable({
          "paging": false,
          "info": false,
          "order": [[8, 'desc']],
          'columnDefs': [{ 'orderable': false, 'targets': 0 }],
          dom: 'Bfrtip',
          buttons: [
            { extend: 'pdf', title: 'Subject Pdf', attr: { id: "pdfBtn" }, exportOptions: { columns: [2, 3, 4, 5, 6, 7, 9] } },
            { extend: 'excel', title: 'Subject Excel', attr: { id: "excelBtn" }, exportOptions: { columns: [2, 3, 4, 5, 6, 7, 9] } }
          ],
          "fnDrawCallback": function () {
            var table = $('#subjectDatatable').DataTable();
            $(table.buttons('.buttons-pdf').nodes()).css("display", "none");
            $(table.buttons('.buttons-excel').nodes()).css("display", "none");
          }
        });
        $("#subjectDatatable_filter").hide();
        $("#subjectDatatable_IsMobile").DataTable({
          "paging": false,
          "info": false,
          "order": [[3, 'desc']],
          'columnDefs': [{ 'orderable': false, 'targets': 0 }],
          dom: 'Bfrtip',
          buttons: [
            { extend: 'pdf', title: 'Subject Pdf', attr: { id: "pdfBtn_IsMobile" }, exportOptions: { columns: [2, 4] } },
            { extend: 'excel', title: 'Subject Excel', attr: { id: "excelBtn_IsMobile" }, exportOptions: { columns: [2, 4] } }
          ],
          "fnDrawCallback": function () {
            var table = $('#subjectDatatable_IsMobile').DataTable();
            $(table.buttons('.buttons-pdf').nodes()).css("display", "none");
            $(table.buttons('.buttons-excel').nodes()).css("display", "none");
          }
        });
        $("#subjectDatatable_IsMobile_filter").hide();
      },
        error => {
          info_noti(error);
        })
  }
  ExportExcel() {
    $("#excelBtn").click();
  }

  ExportPdf() {
    $("#pdfBtn").click();
  }
  ExportExcel_IsMobile() {
    $("#excelBtn_IsMobile").click();
  }

  ExportPdf_IsMobile() {
    $("#pdfBtn_IsMobile").click();
  }
  checkYear(data): Boolean {
    let userDate = new Date(data);
    if (userDate.getFullYear() == this.todayDate.getFullYear()) {
      return true;
    }
    else {
      return false;
    }
  }

  ViewDataBind(data: Approved) {
    Object.assign(this.subjectViewData, data);
  }

  // checkboxChanged(event, obj) {
  //   debugger;
  //   if (event.target.checked) {
  //     this.selectedMailList.push(event.target.value);

  //   }
  //   else {
  //     this.selectedMailList.splice(this.selectedMailList.indexOf(event.target.value), 1);
  //   }
  //   this.selectedMailList = Array.from(new Set(this.selectedMailList));

  //   if (this.selectedMailList.length > 0) {
  //     this.showActions = true;
  //     if (this.checkClickCount == 0) {
  //       this.checkClickCount = 1;
  //       this.approvedObjActionShow = obj;
  //     }
  //   }
  //   else {
  //     this.checkClickCount = 0;
  //     this.approvedObjActionShow = null;
  //     this.showActions = false;
  //   }
  // }

  checkboxChanged(event, obj, status, allSelectedList, type) {
    debugger;
    if (type == "mobile") {
      if (status == "selectAll") {
        if (event.target.checked) {
          var i = 1;
          allSelectedList.forEach(element => {
            this.selectedMailList.push(element.appEmailId);
            $('#checkboxm' + i).prop("checked", true);
            i++;
          })
        } else {

          var i = 1;

          allSelectedList.forEach(element => {
            this.selectedMailList.splice(this.selectedMailList.indexOf(element.appEmailId, 1));

            $('#checkboxm' + i).prop("checked", false);
            i++;
          })
        }

      } else {

        if (event.target.checked) {
          this.selectedMailList.push(obj.appEmailId);
          if (this.selectedMailList.length == this.subjectGrid.length) {
            $('#selectAllm').prop("checked", true);
          }

        }
        else {
          $('#selectAllm').prop("checked", false);
          this.selectedMailList.splice(this.selectedMailList.indexOf(obj.appEmailId), 1);
        }
      }
      this.selectedMailList = Array.from(new Set(this.selectedMailList));

      if (this.selectedMailList.length > 0) {
        this.showActions = true;
        if (this.checkClickCount == 0) {
          this.checkClickCount = 1;
          this.approvedObjActionShow = obj;
        }
      }
      else {
        this.checkClickCount = 0;
        this.approvedObjActionShow = null;
        this.showActions = false;
      }
    } else {
      if (status == "selectAll") {
        if (event.target.checked) {
          var i = 1;
          allSelectedList.forEach(element => {
            this.selectedMailList.push(element.appEmailId);
            $('#checkbox' + i).prop("checked", true);
            i++;
          })
        } else {

          var i = 1;

          allSelectedList.forEach(element => {
            this.selectedMailList.splice(this.selectedMailList.indexOf(element.appEmailId, 1));

            $('#checkbox' + i).prop("checked", false);
            i++;
          })
        }

      } else {

        if (event.target.checked) {
          this.selectedMailList.push(obj.appEmailId);
          if (this.selectedMailList.length == this.subjectGrid.length) {
            $('#selectAll').prop("checked", true);
          }

        }
        else {
          $('#selectAll').prop("checked", false);
          this.selectedMailList.splice(this.selectedMailList.indexOf(obj.appEmailId), 1);
        }
      }
      this.selectedMailList = Array.from(new Set(this.selectedMailList));

      if (this.selectedMailList.length > 0) {
        this.showActions = true;
        if (this.checkClickCount == 0) {
          this.checkClickCount = 1;
          this.approvedObjActionShow = obj;
        }
      }
      else {
        this.checkClickCount = 0;
        this.approvedObjActionShow = null;
        this.showActions = false;
      }
    }

  }



  StarClick(appEmailId, star, status) {
    debugger;
    this._approvedService.starUnstar(appEmailId, star)
      .subscribe((response) => {
        // console.log(response);

        if (star == 1) {
          info_noti('Starred Success...');
        } else {
          info_noti('UnStarred Success...');
        }
        this.GetSubject_Grid();
      })
  }

  // HideClick(appEmailId, hide) {
  //   this._approvedService.hideUnhide(appEmailId, hide)
  //     .subscribe((response) => {
  //    info_noti('Hidden Success...');
  //       this.GetSubject_Grid();
  //     })
  // }
  HideClick(appEmailId, hide, status) {
    if (status == 'ViewModal') {
      $("#ViewModal").modal("hide");
      $("body").removeClass('modal-open');
      $('.modal-backdrop').remove();
    }

    this._approvedService.hideUnhide(appEmailId, hide)
      .subscribe((response) => {
        info_noti('Hidden Success...');
        //  info_noti("Hidden Success...");
        this.GetSubject_Grid();
      })
  }

  //Delete
  DeleteApproved(id: any, status) {
    debugger;
    if (status == 'ViewModal') {
      $("#ViewModal").modal("hide");
      $("body").removeClass('modal-open');
      $('.modal-backdrop').remove();
    }
    this._approvedService.Delete_HealthCard(id)
      .subscribe((response) => {
        debugger;
        info_noti('Deleted Success...');
        this.GetSubject_Grid();
      });
  }


  //multiple delete
  multipleDelete() {
    debugger;
    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.appvar = new Approved();
      this.appvar.appEmailId = Number(this.selectedMailList[i]);
      this.selectedActionList[i] = this.appvar;
    }
    this._approvedService.deleteMultiple(this.selectedActionList).subscribe((response) => {
      info_noti('Deleted Success...');
      this.selectedMailList.length = 0;
      this.appvar
      this.selectedActionList.length = 0;
      if (this.selectedMailList.length > 0) {
        this.showActions = true;
      }
      else {
        this.approvedObjActionShow = null;
        this.checkClickCount = 0;
        this.showActions = false;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetSubject_Grid();
    }, error => { info_noti(error); }
    );
    console.log(this.selectedMailList);
  }


  multipleStar(flag: boolean) {
    debugger;

    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.appvar = new Approved();
      this.appvar.appEmailId = Number(this.selectedMailList[i]);
      this.appvar.star = true;

      this.selectedActionList[i] = this.appvar;
    }
    this._approvedService.starMultiple(this.selectedActionList).subscribe((response) => {
      info_noti('Starred Success...');
      //  info_noti("Starred Success...");
      this.selectedMailList.length = 0;
      this.appvar
      this.selectedActionList.length = 0;
      if (this.selectedMailList.length > 0) {
        this.showActions = flag;
      }
      else {
        this.approvedObjActionShow = null;
        this.showActions = false;
        this.checkClickCount = 0;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetSubject_Grid();
    }, error => { info_noti(error); }
    );


    console.log(this.selectedMailList);

  }
  multipleEye(flag: boolean) {
    debugger;
    for (var i = 0; i < this.selectedMailList.length; i++) {
      this.appvar = new Approved();
      this.appvar.appEmailId = Number(this.selectedMailList[i]);
      this.appvar.hide = flag;
      this.selectedActionList[i] = this.appvar;
    }
    this._approvedService.hideMultiple(this.selectedActionList).subscribe((response) => {
      info_noti('Hidden Success...');
      this.selectedMailList.length = 0;
      this.appvar
      this.selectedActionList.length = 0;
      if (this.selectedMailList.length > 0) {
        this.showActions = true;
      }
      else {
        this.approvedObjActionShow = null;
        this.showActions = false;
        this.checkClickCount = 0;
      }
      $('#selectAll').prop("checked", false);
      $('#selectAllm').prop("checked", false);
      this.GetSubject_Grid();
    }, error => { info_noti(error); }
    );
    console.log(this.selectedMailList);
  }




  enteredEmailIDForForwordEmail(emailId) {
    this.emailId = emailId;
  }
  multipleForword(emailId,form:NgForm) {
    if (emailId != "") {
      $("#multipleForwordBtn").attr("disabled", true);
      for (var i = 0; i < this.selectedMailList.length; i++) {
        this.appvar = new Approved();
        this.appvar.appEmailId = Number(this.selectedMailList[i]);
        this.selectedActionList[i] = this.appvar;
      }
      
      this.sendEmailmultiple.approved = this.selectedActionList;
      // this.sendEmailmultiple.emailid = emailId;
      
      this.sendEmailmultiple.emailid = this.sendEmailForm.controls['toAddress'].value;
      
    
      this._approvedService.forwordMultiple(this.sendEmailmultiple).subscribe((response) => {
        info_noti("Email Send Success...");
        $("#multipleForwordBtn").attr("disabled", false);
        $('#sendForwordemail').val('');
        $("#sendEmailForMultipleForword").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
        this.selectedMailList.length = 0;
        
        this.selectedActionList.length = 0;
        if (this.selectedMailList.length > 0) {
          this.showActions = true;
        }
        else {
          this.approvedObjActionShow = null;
          this.showActions = false;
          this.checkClickCount = 0;
          this.sendEmailmultiple = new sendEmailmultiple;
        }
        $('#selectAll').prop("checked", false);
        $('#selectAllm').prop("checked", false);
        this.GetSubject_Grid();
       
      
      }, error => {
        info_noti("Email Not send");
       
        $("#sendEmailForMultipleForword").modal("hide");
        $("body").removeClass('modal-open');
        $('.modal-backdrop').remove();
      }
      );
      console.log(this.selectedMailList);
    } else {
      this.emailId = '';
      console.log(this.emailId);
    }


  }
	  
	  
	  
	
	  
	    sendEmailForm: FormGroup;
  loadSendEmailForm(){
      this.sendEmailForm = this.fb.group({
        'toAddress': ['', [Validators.required, this.commaSepEmail]]
      });
    }
  
    send(value) {
      console.log(value);
    }
  
    commaSepEmail = (control: AbstractControl): { [key: string]: any } | null => {
      const emails = control.value.split(',');
      const forbidden = emails.some(email => Validators.email(new FormControl(email)));
      console.log(forbidden);
      return forbidden ? { 'toAddress': { value: control.value } } : null;
    };
	
	
	 sendForwordEmailOpen() {
    this.loadSendEmailForm();
    $('#sendForwordemail').focus();

  }

	 
  forwordEmailEnter(sendForwordemail,form:NgForm) {
    $('#multipleForwordBtn').focus();
    this.multipleForword(sendForwordemail,form);
  }


  sendMailClose(form:NgForm) {
    $('#sendForwordemail').val('');
    this.emailId = "";
   
  }


  Attachment_CloseClick() {
    this.attachment_CloseForm.nativeElement.click();
  }

  AttachmentShow_DataBind(data) {
    this.approvedAttachmentDataShow = data;

  }
  Attachment_DataBind(data: any) {
    this.approvedAttachmentData = data;
  }
 
  updateUsingViewModel(id) {
    $("#ViewModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    this.router.navigate(['/dashboard/updatehc/' + id + '/approved']);
  }

  downloadFile(path) {
    window.open(path, '_self');
  }

  //browser back button or mobile back button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {



    $("#ViewModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#AttachmentModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#attchmentShowModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

    $("#sendEmailForMultipleForword").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();

  }

  Eye_ClickViewData(appEmailId) {
    debugger

    if (this.eyeIconViewData == "zmdi-eye") {
      this.eyeIconViewData = "zmdi-eye-off";
      this.HideClick(appEmailId, 0, '');
    } else {
      this.eyeIconViewData = "zmdi-eye";
      this.HideClick(appEmailId, 1, 'ViewModal');
    }


  }
  Star_ClickViewData(appEmailId) {
    debugger

    if (this.starIconViewData == "zmdi-star") {
      this.starIconViewData = "zmdi-star-outline";
      this.StarClick(appEmailId, 0, 'viewData');
    } else {
      this.starIconViewData = "zmdi-star";
      this.StarClick(appEmailId, 1, 'viewData');
    }

  }
}
